import React from 'react'
import { LEASE_STATUS_COLOR_OPACITY, getLeaseStatusColor, getLeaseStatusLabel } from '../../leaseStatus'
import styles from './StatusCell.module.scss'

interface StatusCellProps {
  status?: string
}

const StatusCell = ({ status }: StatusCellProps) => (
  <span className={styles.root}>
    <span
      className={styles.marker}
      style={{ backgroundColor: getLeaseStatusColor(status), opacity: LEASE_STATUS_COLOR_OPACITY }}
    />
    {getLeaseStatusLabel(status)}
  </span>
)

export default StatusCell
